export const DashboardDetailType = {
    SCENARIO: 'scenario',
    DISPATCHER: 'dispatcher',
};
